import script from "./UploadSID.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadSID.vue?vue&type=script&setup=true&lang=js"

import "./UploadSID.vue?vue&type=style&index=0&id=98a06876&lang=css"

const __exports__ = script;

export default __exports__